import PropTypes from 'prop-types';
import React from 'react';

function ToolboxMenuItem({
  label,
  shortcut,
  width = undefined,
  name = undefined,
}: {
  label: string|undefined
  shortcut: string|undefined
  width?: string|undefined
  name?: string|undefined
}) {
  return (
    <div  style={{width: width ?? '130px'}}>
      <div id={`${name}-${label}`} className="float-left">{label}</div>
      <div className="float-right" style={{paddingRight: '15px'}}>{shortcut}</div>
      <div className="clearfix"></div>
    </div>
  );
}

ToolboxMenuItem.defaultProps = {
};

ToolboxMenuItem.propTypes = {
  label: PropTypes.string,
  shortcut: PropTypes.string,
  width: PropTypes.string,
};

export default React.memo(ToolboxMenuItem);
